import React from "react";
import { Routes, Route } from "react-router-dom";
import { Helmet } from "react-helmet";
import Landing from "./screens/Landing.jsx";
import ServicesAdmin from "./screens/ServicesAdmin";
import ServicesDesc from "./screens/ServicesDesc";
import MessagesAdmin from "./screens/MessagesAdmin";
import Login from "./screens/Login";
import SalesAdmin from "./screens/SalesAdmin";
import UsersAdmin from "./screens/UsersAdmin";
import ClientDashboard from "./screens/ClientDashboard";
import Checkout from "./screens/Checkout";
import PropertiesPage from "./screens/PropertiesPage";
import PropertyDetail from "./screens/PropertyDetail";
import AdminLogin from "./screens/AdminLogin";
import AdminDashboard from "./screens/AdminDashboard";
import AboutUs from "./screens/AboutUs";
import Clients from "./screens/Clients";
import PublicService from "./screens/PublicService";
import ContactPage from "./screens/ContactPage";
import ScrollToTop from "./components/ScrollToTop.jsx";
import ArrowScroll from "./components/ArrowScroll.jsx";

export default function App() {
  return (
    <>
      <Helmet>
        <link rel="preconnect" href="https://fonts.googleapis.com" />
        <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="true" />
        <link href="https://fonts.googleapis.com/css2?family=Khula:wght@400;600;800&display=swap" rel="stylesheet" />
      </Helmet>

      <ScrollToTop />
      <ArrowScroll />

      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/services" element={<PublicService />} />
        <Route path="/service-desc/:srvId" element={<ServicesDesc />} />
        <Route path="/messages" element={<MessagesAdmin />} />
        <Route path="/login" element={<Login />} />
        <Route path="/sales" element={<SalesAdmin />} />
        <Route path="/users" element={<UsersAdmin />} />
        <Route path="/dashboard" element={<ClientDashboard />} />
        <Route path="/checkout" element={<Checkout />} />
        <Route path="/properties" element={<PropertiesPage />} />
        <Route path="/properties/:id" element={<PropertyDetail />} />
        <Route path="/about-us" element={<AboutUs />} />
        <Route path="/clients" element={<Clients />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/services/:serviceSlug" element={<PublicService />} />
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin" element={<AdminDashboard />} />
      </Routes>
    </>
  );
}
